import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider, App } from "antd";
import { Provider } from "react-redux";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact, { BugsnagErrorBoundary } from "@bugsnag/plugin-react";

import { store } from "./store";
import "./index.css";
import "./assets/scss/_main-dir.scss";
import "./assets/less/_main-dir.less";
import AppTsx from "./App";
import config from "./config";

// ─── Bugsnag ──────────────────────────────────────────────────────────────────
let ErrorBoundary: BugsnagErrorBoundary | null = null;

if (config.BUGSNAG_APIKEY) {
  Bugsnag.start({
    apiKey: config.BUGSNAG_APIKEY,
    plugins: [new BugsnagPluginReact()],
  });
  ErrorBoundary = Bugsnag.getPlugin("react")!.createErrorBoundary(React);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#fdb415",
            borderRadius: 6,
          },
          components: {
            Button: {
              colorPrimary: "#fdb415",
            },
          },
        }}
      >
        <App>
          <BrowserRouter>
            {ErrorBoundary ? (
              <ErrorBoundary>
                <AppTsx />
              </ErrorBoundary>
            ) : (
              <AppTsx />
            )}
          </BrowserRouter>
        </App>
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
);